
(function(){
  'use strict';
  function init(){
    const form=document.getElementById('prepForm');
    const grid=document.getElementById('prepChecks');
    const label=document.getElementById('progressLabel');
    const fill=document.getElementById('progressFill');
    const bar=document.getElementById('supplyProgress');
    if(!form || !grid || !label || !fill || !bar) return;
    const boxes=Array.from(grid.querySelectorAll('input[data-supply-check]'));
    const total=boxes.length;
    const key='little-clay-club-v4-prep';
    try {
      const saved=JSON.parse(localStorage.getItem(key)||'null');
      if(Array.isArray(saved) && saved.length===total){
        boxes.forEach((box,i)=>{box.checked=saved[i]===true;});
      }
    } catch(_ignored) {}
    function update(){
      const count=boxes.reduce((n,box)=>n+(box.checked?1:0),0);
      label.textContent=count+'/'+total;
      label.setAttribute('aria-label',count+' of '+total+' essentials gathered');
      bar.setAttribute('aria-valuenow',String(count));
      bar.setAttribute('aria-valuemax',String(total));
      fill.style.width=total?(count/total*100)+'%':'0%';
      boxes.forEach(box=>box.closest('label').classList.toggle('is-ready',box.checked));
      try {localStorage.setItem(key,JSON.stringify(boxes.map(box=>box.checked)));}catch(_ignored){}
    }
    grid.addEventListener('change',e=>{if(e.target.matches('input[data-supply-check]'))update()});
    // The native form reset works even without JS. After it resets the
    // input elements, mirror the state into storage and ARIA attributes.
    form.addEventListener('reset',()=>{
      boxes.forEach(box=>box.checked=false);
      update();
    });
    window.addEventListener('pageshow',update);
    update();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();